import { render } from "./tab-riwayat-follow-up.vue?vue&type=template&id=2f2464a0&scoped=true&ts=true"
import script from "./tab-riwayat-follow-up.vue?vue&type=script&lang=ts"
export * from "./tab-riwayat-follow-up.vue?vue&type=script&lang=ts"

import "./tab-riwayat-follow-up.vue?vue&type=style&index=0&id=2f2464a0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f2464a0"]])

export default __exports__